(function () {
  'use strict';

  if (window.LFInventoryGuardLoaded) return;
  window.LFInventoryGuardLoaded = true;

  var WHATSAPP_URL = 'https://wa.link/3fu7so';
  var allowNextClick = new WeakSet();
  var allowNextSubmit = new WeakSet();

  function showMessage(message, whatsapp) {
    var host =
      document.querySelector('[data-cart-page]') ||
      document.querySelector('cart-drawer') ||
      document.body;

    var box = host.querySelector('[data-lf-inventory-message]');

    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-lf-inventory-message', '');
      box.setAttribute('role', 'alert');
      box.style.cssText =
        'margin:12px 0;padding:14px;background:#fff;border:1px solid #000099;' +
        'border-radius:6px;color:#151515;font-size:14px;line-height:1.45;';
      host.prepend(box);
    }

    box.innerHTML =
      '<strong>Inventario:</strong> ' + message +
      (whatsapp
        ? '<br><a href="' + WHATSAPP_URL + '" target="_blank" rel="noopener" ' +
          'style="display:inline-block;margin-top:10px;padding:10px 16px;' +
          'background:#000099;color:#fff;border-radius:5px;text-decoration:none;' +
          'font-weight:700;">Gestionar por WhatsApp</a>'
        : '');

    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearMessage() {
    var box = document.querySelector('[data-lf-inventory-message]');
    if (box) box.remove();
  }

  function getCart() {
    return fetch('/cart.js?_=' + Date.now(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('No fue posible consultar el carrito.');
      return response.json();
    });
  }

  function getVariantState(item) {
    var url =
      '/products/' + encodeURIComponent(item.handle) +
      '?section_id=api-live-cart-info' +
      '&variant=' + encodeURIComponent(item.variant_id) +
      '&_=' + Date.now();

    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('No fue posible consultar el inventario.');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var state = doc.querySelector('[data-lf-inventory-state]');
        var quantity = doc.querySelector('[data-item-count-for-variant]');
        var stock = doc.querySelector('[data-max-inventory]');

        if (!state || !quantity || !stock) {
          throw new Error('La respuesta de inventario no es válida.');
        }

        return {
          protected: state.getAttribute('data-protected') === 'true',
          title: state.getAttribute('data-product-title') || item.product_title,
          cartQuantity: Number(quantity.textContent.trim() || 0),
          stock: stock.textContent.trim() === ''
            ? null
            : Number(stock.textContent.trim())
        };
      });
  }

  function validateCart() {
    return getCart().then(function (cart) {
      var variants = {};

      cart.items.forEach(function (item) {
        variants[item.variant_id] = item;
      });

      return Promise.all(
        Object.keys(variants).map(function (id) {
          return getVariantState(variants[id]);
        })
      );
    }).then(function (states) {
      for (var i = 0; i < states.length; i++) {
        var item = states[i];

        if (!item.protected) continue;

        if (!Number.isFinite(item.stock)) {
          return {
            ok: false,
            message: 'No fue posible comprobar el inventario actual. Por favor, inténtelo de nuevo.'
          };
        }

        if (item.stock <= 0) {
          return {
            ok: false,
            message: item.title + ' está agotado.'
          };
        }

        if (item.cartQuantity > item.stock) {
          return {
            ok: false,
            message:
              'La cantidad solicitada de ' + item.title +
              ' supera las ' + item.stock + ' unidades disponibles.'
          };
        }
      }

      return { ok: true };
    });
  }

  function validateBeforeCheckout(trigger, continueAction) {
    clearMessage();

    validateCart()
      .then(function (result) {
        if (!result.ok) {
          showMessage(result.message, result.whatsapp);
          return;
        }

        continueAction();
      })
      .catch(function () {
        showMessage(
          'No fue posible comprobar el inventario actual. Por favor, inténtelo de nuevo.',
          false
        );
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      'button[name="checkout"], #lf-modal-pay, a[href="/checkout"]'
    );

    if (!button) return;

    if (allowNextClick.has(button)) {
      allowNextClick.delete(button);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    validateBeforeCheckout(button, function () {
      var form = button.closest('form[action="/cart"]');
      if (form) allowNextSubmit.add(form);

      allowNextClick.add(button);
      button.click();
    });
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute('action') || '') !== '/cart') return;

    if (allowNextSubmit.has(form)) {
      allowNextSubmit.delete(form);
      return;
    }

    if (!event.submitter || event.submitter.name !== 'checkout') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    validateBeforeCheckout(form, function () {
      allowNextSubmit.add(form);

      if (form.requestSubmit) {
        form.requestSubmit(event.submitter);
      } else {
        form.submit();
      }
    });
  }, true);

  function hideAcceleratedCheckout() {
    if (!document.getElementById('lf-co-main')) return;

    document
      .querySelectorAll(
        '.additional-checkout-buttons, [data-additional-checkout-button]'
      )
      .forEach(function (element) {
        element.style.display = 'none';
      });
  }

  document.addEventListener('DOMContentLoaded', hideAcceleratedCheckout);
  hideAcceleratedCheckout();
})();

/* Revisión automática al reabrir un carrito guardado */
(function () {
  if (!/\/cart\/?$/.test(window.location.pathname)) return;

  function bloquearPago(mensaje) {
    let aviso = document.getElementById('lf-stock-cart-open-warning');

    if (!aviso) {
      aviso = document.createElement('div');
      aviso.id = 'lf-stock-cart-open-warning';
      aviso.style.cssText =
        'margin:16px 0;padding:16px;border:1px solid #dc3545;background:#f8d7da;color:#842029;border-radius:4px;font-weight:600;';
      const destino = document.querySelector('form[action="/cart"]') || document.querySelector('main');
      destino?.prepend(aviso);
    }

    aviso.textContent = mensaje;

    document.querySelectorAll('button[name="checkout"], #lf-modal-pay, a[href="/checkout"]').forEach((elemento) => {
      if (elemento.tagName === 'BUTTON') {
        elemento.disabled = true;
        elemento.setAttribute('aria-disabled', 'true');
      } else {
        elemento.addEventListener('click', (evento) => {
          evento.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    });
  }

  async function revisarCarritoGuardado() {
    try {
      const carrito = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => {
        if (!r.ok) throw new Error('No se pudo leer el carrito');
        return r.json();
      });

      const variantes = new Map();

      carrito.items.forEach((item) => {
        const actual = variantes.get(item.variant_id) || {
          cantidad: 0,
          titulo: item.product_title,
          url: item.url
        };
        actual.cantidad += item.quantity;
        variantes.set(item.variant_id, actual);
      });

      const revisiones = await Promise.all(
        [...variantes.entries()].map(async ([variantId, item]) => {
          const endpoint = new URL(item.url, window.location.origin);
          endpoint.search = new URLSearchParams({
            section_id: 'api-live-cart-info',
            variant: variantId
          }).toString();

          const html = await fetch(endpoint.toString(), { credentials: 'same-origin' }).then((r) => {
            if (!r.ok) throw new Error('No se pudo verificar inventario');
            return r.text();
          });

          const documento = new DOMParser().parseFromString(html, 'text/html');
          const datoStock = documento.querySelector('[data-max-inventory]')?.textContent?.trim();

          if (!datoStock) return null;

          return {
            titulo: item.titulo,
            cantidad: item.cantidad,
            stock: Number(datoStock)
          };
        })
      );

      const sinStock = revisiones.find((item) => item && (item.stock <= 0 || item.cantidad > item.stock));

      if (sinStock) {
        bloquearPago(
          `El inventario de “${sinStock.titulo}” cambió. Revise la cantidad o elimine el producto antes de continuar al pago.`
        );
      }
    } catch (error) {
      bloquearPago('No fue posible confirmar las existencias actuales. Revise el carrito antes de continuar al pago.');
    }
  }

  revisarCarritoGuardado();
})();